import './Loader.scss';

const Loader = ({fullScreen}) => {
    return (
        <div className={`wallet-loader${fullScreen ? ' wallet-loader--full' : ''}`}>
            <div className="wallet-loader__ring" aria-label="Loading" role="status">
                <div className="wallet-loader__ring-inner"/>
            </div>
        </div>
    );
};

export default Loader;